/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit AddUser.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Svg = css({label: 'Svg',
  alignSelf: 'var(--alignSelf)',
marginTop: 'var(--marginTop)',
marginBottom: 'var(--marginBottom)',
marginLeft: 'var(--marginLeft)',
marginRight: 'var(--marginRight)',
opacity: 'var(--opacity)',
width: 'var(--width)',
height: 'var(--height)'})
styles.SvgPath = css({label: 'SvgPath',
  fill: 'var(--fill)',
stroke: 'var(--stroke)'})
styles.SvgCircle = css({label: 'SvgCircle',
  fill: 'var(--fill)',
stroke: 'var(--stroke)'})
styles.SvgPath1 = css({label: 'SvgPath1',
  fill: 'var(--fill)',
stroke: 'var(--stroke)'})

export default function AddUser({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  alignSelf= "auto",
marginTop= 0,
marginBottom= 0,
marginLeft= 0,
marginRight= 0,
opacity= 1,
width= 48,
height= 32,
fill= "none",
stroke= "#2E2E2E"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<svg
 data-testid="AddUser.Svg"
 data-view-path={dataViewPath}
 viewBox="0 0 48 32"
 style={{'--alignSelf': alignSelf,'--marginTop': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--marginBottom': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--marginLeft': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--marginRight': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--opacity': opacity,'--width': typeof width === 'number' ? `${width}px` : width,'--height': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
 data-testid="AddUser.SvgPath"
 data-view-path={dataViewPath}
 strokeWidth={2}
 strokeMiterlimit={10}
 d="M9.8 10.7v10.6M15.1 16H4.4"
 style={{'--fill': fill,'--stroke': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<circle
 data-testid="AddUser.SvgCircle"
 data-view-path={dataViewPath}
 strokeWidth={2}
 strokeMiterlimit={10}
 cx={30.5}
 cy={14.2}
 r={7.7}
 style={{'--fill': fill,'--stroke': stroke}}
 className={`views-block ${styles.SvgCircle}`}
/>
<path
 data-testid="AddUser.SvgPath:1"
 data-view-path={dataViewPath}
 strokeWidth={2}
 strokeMiterlimit={10}
 d="M21.1 26.5c5.2-5.2 13.6-5.2 18.8 0"
 style={{'--fill': fill,'--stroke': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}